import type us from './enUS.js'
import esES from './esES.js'

const currentYear = new Date().getUTCFullYear()

const esUS: typeof us = {
  ...esES,
  Header: {
    ...esES.Header,
    titleFormat: (count: number, category: string) => `Los ${count} mejores ${category} ${currentYear}`,
  },
  CategoriesSearchPage: {
    title: 'Más opciones de las listas mejor valoradas',
    bySearchTerm: 'Por términos de búsqueda:',
    viewList: 'Ver lista',
  },
  ProductCard: {
    ...esES.ProductCard,
    ctaText: (trafficType?: string, _partnerName?: string) => {
      switch (trafficType) {
        case 'organic-amazon-only':
          return 'Más información'
        case 'paid-long-tail':
          return 'Más información'
        case 'organic-buying-options':
          return 'Ver el producto'
        case 'dws':
          return 'Ver oferta'
        default:
          return 'Ver en Amazon'
      }
    },
  },
}
export default esUS
